/** Must match `basePath` in `next.config.js` (used when `window` is unavailable). */
const FALLBACK_BASE_PATH = '/organizer-profile';

/**
 * Resolved app base path (e.g. `/organizer-profile`) for static assets and `fetch`.
 */
export function getBasePath(): string {
  if (typeof window !== 'undefined') {
    return (
      (
        window as unknown as {
          __NEXT_DATA__?: { config?: { basePath?: string } };
        }
      ).__NEXT_DATA__?.config?.basePath ?? FALLBACK_BASE_PATH
    );
  }
  return FALLBACK_BASE_PATH;
}

/**
 * Prefix a path with Next.js `basePath` (e.g. `/cover.jpg` → `/organizer-profile/cover.jpg`).
 */
export function withBasePath(path: string): string {
  const base = getBasePath();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}
